import type {ViewerAPI} from '@wix/viewer-manager-interface'
import {VIEW_MODES} from './constants/constants'

const getViewMode = (viewer: ViewerAPI): string =>
    viewer.viewMode.isMobileView() ? VIEW_MODES.MOBILE : VIEW_MODES.DESKTOP

const isSameViewMode = (viewer: ViewerAPI, type?: string): boolean => type === getViewMode(viewer)

const decodeCompsToHideProps = (id: string): {compId: string; viewMode: string; innerElementPath?: string[]} => {
    const idSplit = id.split('_')
    const innerElementPathIndex = idSplit.indexOf('innerElementPath')
    const hasInnerElementPath = innerElementPathIndex !== -1
    const compId = hasInnerElementPath ? idSplit.slice(2, innerElementPathIndex).join('_') : idSplit.slice(2).join('_')
    const viewMode = idSplit[1]
    const innerElementPath = hasInnerElementPath ? idSplit[innerElementPathIndex + 1].split(',') : undefined
    return {compId, viewMode, innerElementPath}
}

export {isSameViewMode, getViewMode, decodeCompsToHideProps}
